import React from 'react';

const PasswordRequirement = ({ met, text }) => (
  <li className={`flex items-center transition-colors duration-300 ${met ? 'text-green-600' : 'text-gray-500'}`}>
    <svg
      className={`w-4 h-4 mr-2 transition-transform duration-300 ${met ? 'transform scale-110' : ''}`}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      {met ? (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
      ) : (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
      )}
    </svg>
    {text}
  </li>
);

const PasswordStrengthIndicator = ({ password }) => {
  const checks = {
    length: password.length >= 8,
    lowercase: /(?=.*[a-z])/.test(password),
    uppercase: /(?=.*[A-Z])/.test(password),
    number: /(?=.*\d)/.test(password),
  };

  const allMet = Object.values(checks).every(Boolean);

  return (
    <div className={`mt-2 p-3 bg-gray-50 rounded-lg border border-gray-200 transition-all duration-300 ${allMet ? 'border-green-200' : ''}`}>
      <p className="text-sm font-semibold text-gray-700 mb-2">Password must contain:</p>
      <ul className="space-y-1 text-sm">
        <PasswordRequirement met={checks.length} text="At least 8 characters" />
        <PasswordRequirement met={checks.lowercase} text="A lowercase letter (a-z)" />
        <PasswordRequirement met={checks.uppercase} text="An uppercase letter (A-Z)" />
        <PasswordRequirement met={checks.number} text="A number (0-9)" />
      </ul>
    </div>
  );
};

export default PasswordStrengthIndicator;
